module.exports = __webpack_public_path__ + "static/partial01-240c479619943962e87c1013a8107ffb.jpg";